module.exports = __webpack_public_path__ + "img/angle-right_black.41c39d85.svg";